/**
 * @description jQuery plugin: https://github.com/flot/flot
 */
;(function () {
  angular
    .module('contrast.flot')
    .directive('asyncRangeFlotChart', function ($) {
      'ngInject'

      return {
        restrict: 'EA',
        link: function (scope, element, attr) {
          scope.$watch(
            attr.chartModel,
            function (x) {
              if (x && x.data && x.data.length > 0) {
                x.options.xaxis.tickSize = tickSize(attr.chartRange)
                $.plot(element, x.data, x.options)
              }
            },
            true
          )

          function tickSize(currentRange) {
            if (currentRange == 'hours') {
              return [4, 'hour']
            } else if (currentRange == 'days') {
              return [1, 'day']
            } else if (currentRange == 'months') {
              return [15, 'day']
            } else if (currentRange == 'hour') {
              return [10, 'minute']
            } else if (currentRange == 'day') {
              return [4, 'hour']
            } else if (currentRange == 'week') {
              return [1, 'day']
            } else if (currentRange == 'month') {
              return [4, 'day']
            }

            return [1, 'day']
          }
        }
      }
    })
})()
